module.exports = __webpack_public_path__ + "static/media/mandate.3e404d9e.svg";